import React, { useEffect, useMemo, useState } from "react";
import _ from "lodash";
import * as providerActionCreators from "../../../load-build/orders/actions";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { TextField, Select, MenuItem, FormControl, InputLabel, Checkbox } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { internalQuoteDialogTheme } from "../../utility/constants";
import { log } from "../../../Helper";

function InternalQuoteForm({ onProviderSelection, preSelectedProvider, onProviderSelectionUpdate } ) {
  const { load } = bindActionCreators(providerActionCreators, useDispatch());
  const providerList = useSelector((storeState) => storeState.getProviderList);

  const pl = useMemo(
    () =>
      providerList.sort(function (a, b) {
        return a.descr.localeCompare(b.descr, "en", { sensitivity: "base" });
      }),
    [providerList]
  );

  const [selectedProviders, setSelectedProviders] = useState([]); //contains all the providers selected in the dialog.
  const [selectAll, setSelectAll] = useState(false);
  const [initialSelectedProviders, setInitialSelectedProviders] = useState([]); // Contains initailly selected providers i.e. preselected providers
  const [uncheckedInitialProviders, setUncheckedInitialProviders] = useState([]); // unchecked preselected providers
  const [newlySelectedProviders, setNewlySelectedProviders] = useState([]); //newly selected providers other than preselected.

  // Load all providers
  useEffect(() => {
    load();
  }, []);

  useEffect(() => {
    if (preSelectedProvider) {
      const preSelectedProviderIdList = preSelectedProvider
        .split(", ")
        .map(Number);
      setSelectedProviders(preSelectedProviderIdList);
      setInitialSelectedProviders(preSelectedProviderIdList);
    }
  }, [preSelectedProvider]); // useeffect to fill preselected provider which we receive from backend.


  useEffect(() => {
    onProviderSelection(selectedProviders);
    setUncheckedInitialProviders(
      initialSelectedProviders.filter((id) => !selectedProviders.includes(id))
    );
    setNewlySelectedProviders(
      selectedProviders.filter((id) => !initialSelectedProviders.includes(id))
    );
  }, [selectedProviders]); // useeffect to monitor selected provider state change and calculate unchecked and newly provider.

  useEffect(() => {
    // Call the parent's component (i.e. InternalQuoteForm) to pass the states whenever they change
    onProviderSelectionUpdate( uncheckedInitialProviders, newlySelectedProviders); // Call the parent's component (i.e. InternalQuoteForm) to pass the states whenever they change
  }, [uncheckedInitialProviders, newlySelectedProviders]); 

  const handleSelect = (provider) => {
    if (selectedProviders.includes(provider.providerId)) {
      setSelectedProviders(
        selectedProviders.filter((id) => id !== provider.providerId)
      );
    } else {
      setSelectedProviders([...selectedProviders, provider.providerId]);
    }
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedProviders([]);
    } else {
      setSelectedProviders(providerList.map((provider) => provider.providerId));
    }
    setSelectAll(!selectAll);
  };

  return (
    <ThemeProvider theme={internalQuoteDialogTheme}>
      <div id="quote-form-main-div" className="text-xs">
        <div className="p-3 flex flex-wrap">
          <div className="w-full">
          <Checkbox
              color="secondary"
              size="small"
              checked={selectAll}
              onChange={handleSelectAll}
            />
            Select All
          </div>
          {pl.map((provider) => (
            <div className="w-1/6" key={provider.providerId}>
              <Checkbox
                className="custom-checkbox"
                color="secondary"
                size="small"
                checked={selectedProviders.includes(provider.providerId)}
                onChange={() => handleSelect(provider)}
              />
              {provider.descr.length > 10 ? (
                <span title={provider.descr}>
                  {provider.descr.substring(0, 10) + "..."}
                </span>
              ) : (
                provider.descr
              )}
            </div>
          ))}
        </div>
      </div>
    </ThemeProvider>
  );
}

export default InternalQuoteForm;
